export interface Feature {
  icon: string;
  title: string;
  description: string;
}

export const features: Feature[] = [
  {
    icon: 'ri-database-2-line',
    title: 'Complete Spreadsheet Database',
    description: 'Access organized product information and research resources spanning thousands of items across multiple shopping categories, all carefully structured for easy browsing and comparison.',
  },
  {
    icon: 'ri-scales-3-line',
    title: 'Category Comparison',
    description: 'Compare products, platforms and shopping methods side by side with detailed breakdowns that help you make informed purchasing decisions quickly and confidently.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Safety Education',
    description: 'Learn how to identify potential risks, verify seller credibility, and avoid unreliable websites with our comprehensive safety guides and best practice recommendations.',
  },
  {
    icon: 'ri-book-open-line',
    title: 'Beginner Tutorials',
    description: 'Step-by-step guides designed for new users — from your first product search to advanced spreadsheet techniques, we cover everything you need to get started.',
  },
];